var _a;
import { ConverterType } from '../domain';
export var timestamp = (_a = {
        types: ['google.protobuf.Timestamp']
    },
    _a[ConverterType.TO_JSON] = {
        transform: function (val) { return val.toISOString(); },
    },
    _a[ConverterType.FROM_JSON] = {
        transform: function (val) { return new Date(val); },
    },
    _a);
//# sourceMappingURL=timestamp.js.map